/**
 * 클립보드 복사 — HTTP(비보안 컨텍스트) 환경에서도 동작하도록 폴백 포함.
 *
 * <p>{@code navigator.clipboard} 는 HTTPS·localhost(보안 컨텍스트)에서만 존재한다.
 * HTTP 로 배포된 서버에서는 {@code undefined} 라 {@code writeText} 호출이 예외가 되므로,
 * 임시 {@code <textarea>} + {@code execCommand('copy')} 로 폴백한다.
 *
 * @param {string} text 복사할 텍스트
 * @returns {Promise<boolean>} 복사 성공 여부
 */
export async function copyToClipboard(text) {
    const str = String(text ?? "");

    // 1) 표준 Clipboard API — 보안 컨텍스트(HTTPS·localhost)에서만 사용
    if (navigator.clipboard && window.isSecureContext) {
        try {
            await navigator.clipboard.writeText(str);
            return true;
        } catch {
            // 권한 거부 등 — 폴백으로 진행
        }
    }

    // 2) 폴백 — 임시 textarea 선택 후 execCommand('copy') (HTTP 에서도 동작)
    try {
        const ta = document.createElement("textarea");
        ta.value = str;
        ta.setAttribute("readonly", "");
        // 화면 밖 배치(투명도 0 은 일부 브라우저가 복사를 건너뛰므로 사용하지 않음)
        ta.style.position = "fixed";
        ta.style.left = "-9999px";
        ta.style.top = "0";
        document.body.appendChild(ta);
        ta.focus();
        ta.select();
        ta.setSelectionRange(0, str.length);
        const ok = document.execCommand("copy");
        document.body.removeChild(ta);
        return ok;
    } catch {
        return false;
    }
}
